import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import AXIOSCONFIGMETHOD from "../../../Axios/axiosConfigMethod";
import { webServiceUrl } from "../../../core/api_utils/webserviceUrl";
import Loading from "../../../core/common/custom-loading/Loading";
import { toast } from "react-toastify";
import { SalesGroup } from "../../../type/group.types";
import React from "react";

interface Member {
    employee_id: string;
    organization_user_id: string;
    email_id: string;
    full_name: string;
    mobile_no: number;
}

interface FormData {
    groupName: string;
    description: string;
    selectedMembers: Member[];
    search: string;
}

const EditGroupPage = () => {
    const routes = all_routes;
    const navigate = useNavigate();
    const { group_id } = useParams();
    const organizationId = localStorage.getItem("organization_id");

    const [loading, setLoading] = useState(false);
    const [members, setMembers] = useState<Member[]>([]);
    const [filtered, setFiltered] = useState<Member[]>([]);
    const [groupData, setGroupData] = useState<SalesGroup | null>(null);
    const [isFocused, setIsFocused] = useState(false);

    const [formData, setFormData] = useState<FormData>({
        groupName: "",
        description: "",
        selectedMembers: [],
        search: "",
    });

    // ------------------------------
    // FETCH GROUP DETAILS
    // ------------------------------
    // const getViewSingleGroup = async () => {
    //     if (!organizationId) {
    //         toast.error("Organization ID not found");
    //         navigate("/login");
    //         return;
    //     }

    //     try {
    //         setLoading(true);
    //         const response = await AXIOSCONFIGMETHOD(
    //             "post",
    //             webServiceUrl.VIEW_GROUPS,
    //             organizationId
    //         );

    //         if (response?.success) {
    //             const groups: SalesGroup[] = response.data || [];
    //             const selected = groups.find((g:any) => g.group_id === group_id);

    //             if (!selected) {
    //                 toast.error("Group not found");
    //                 return;
    //             }

    //             setGroupData(selected);

    //             // 🔍 Fix missing team_members property
    //             const teamMembers: string[] = (selected as any).team_members || [];

    //             // Pre-select members
    //             const preSelected = members.filter((m) =>
    //                 teamMembers.includes(m.organization_user_id)
    //             );

    //             setFormData((prev) => ({
    //                 ...prev,
    //                 groupName: selected.group_name ?? "",
    //                 description: selected.group_description ?? "",
    //                 selectedMembers: preSelected,
    //             }));
    //         }
    //     } catch (error) {
    //         toast.error("Failed to load group details");
    //     } finally {
    //         setLoading(false);
    //     }
    // };
    const getViewSingleGroup = async () => {
        try {
            setLoading(true);

            const payload = {
                organization_id: organizationId,
            };

            const response = await AXIOSCONFIGMETHOD(
                "post",
                webServiceUrl.VIEW_GROUPS,
                payload
            );

            if (response?.success) {
                const allGroups = response.data;
                const selected = allGroups.find(
                    (g: any) => g.group_id === Number(group_id)
                );

                // console.log(allGroups)

                if (!selected) {
                    toast.error("Group not found");
                    return;
                }

                const groupMembers = (selected.group_memebers || []).map((gm: any) => ({
                    employee_id: gm.sales_user_id,
                    organization_user_id: gm.sales_user_id,
                    full_name: gm.sales_user_name,
                    mobile_no: gm.sales_user_contact_number,
                    // email_id: ""
                }));

                setFormData((prev) => ({
                    ...prev,
                    groupName: selected.group_name,
                    description: selected.group_description,
                    selectedMembers: groupMembers,
                }));
            }
        } catch (error) {
            console.log(error);
            toast.error("Failed to fetch group details");
        } finally {
            setLoading(false);
        }
    };

    // ------------------------------
    // FETCH SALES MEMBERS
    // ------------------------------
    const SalesTeamData = async () => {
        try {
            setLoading(true);

            const response = await AXIOSCONFIGMETHOD(
                "post",
                webServiceUrl.SALES_TEAM,
                { organization_id: organizationId }
            );



            if (response?.success) {
                // 🔧 Ensure ID types are correct
                const normalized = response.data.map((m: any) => ({
                    ...m,
                    employee_id: String(m.employee_id),
                }));

                console.log("This is normalized data: ", normalized)
                setMembers(normalized);
                setFiltered(normalized);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const handleRemove = (id: string) =>
        setFormData((prev) => ({
            ...prev,
            selectedMembers: prev.selectedMembers.filter((m) => m.employee_id !== id),
        }));


    const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            const newSelected = [
                ...formData.selectedMembers,
                ...filtered.filter(
                    (m) =>
                        !formData.selectedMembers.some(
                            (s) => s.organization_user_id === m.organization_user_id
                        )
                ),
            ];
            setFormData((prev) => ({ ...prev, selectedMembers: newSelected }));
        } else {
            const remaining = formData.selectedMembers.filter(
                (s) => !filtered.some((m) => m.organization_user_id === s.organization_user_id)
            );
            setFormData((prev) => ({ ...prev, selectedMembers: remaining }));
        }
    };

    // const handleCheckboxSelect = (member: Member) => {
    //     const isSelected = formData.selectedMembers.some(
    //         (s) => s.organization_user_id === member.organization_user_id
    //     );
    //     setFormData((prev) => ({
    //         ...prev,
    //         selectedMembers: isSelected
    //             ? prev.selectedMembers.filter(
    //                 (s) => s.organization_user_id !== member.organization_user_id
    //             )
    //             : [...prev.selectedMembers, member],
    //     }));
    // };

    const handleCheckboxSelect = (member: Member) => {
        const isSelected = formData.selectedMembers.some(
            (s) => s.organization_user_id === member.organization_user_id
        );

        setFormData((prev) => ({
            ...prev,
            selectedMembers: isSelected
                ? prev.selectedMembers.filter((s) => s.organization_user_id !== member.organization_user_id)
                : [...prev.selectedMembers, member],
        }));
    };


    useEffect(() => {
        SalesTeamData();
    }, []);

    useEffect(() => {
        if (members.length > 0) {
            getViewSingleGroup();
        }
    }, [members]);

    // Search filter
    useEffect(() => {
        const s = formData.search.toLowerCase();
        setFiltered(
            members.filter((m) => m.full_name.toLowerCase().includes(s))
        );
    }, [formData.search, members]);

    // ------------------------------
    // MEMBER SELECTION
    // ------------------------------
    const toggleMember = (member: Member) => {
        const isSelected = formData.selectedMembers.some(
            (s) => s.organization_user_id === member.organization_user_id
        );

        setFormData((prev) => ({
            ...prev,
            selectedMembers: isSelected
                ? prev.selectedMembers.filter(
                    (s) => s.organization_user_id !== member.organization_user_id
                )
                : [...prev.selectedMembers, member],
        }));
    };

    // ------------------------------
    // UPDATE GROUP
    // ------------------------------
    const handleUpdateGroup = async () => {
        if (!formData.groupName.trim()) return toast.error("Enter group name.");
        if (!formData.description.trim()) return toast.error("Enter description.");
        if (formData.selectedMembers.length === 0)
            return toast.error("Select at least one member.");

        const UPDATE_ENDPOINT =
            webServiceUrl.EDIT_GROUPS;

        const payload = {
            group_id,
            organization_id: organizationId,
            group_name: formData.groupName,
            group_description: formData.description,
            team_members: formData.selectedMembers.map(
                (m) => m.organization_user_id
            ),
        };

        console.log("This is palyload:",payload);
        

        try {
            setLoading(true);

            const response = await AXIOSCONFIGMETHOD(
                "post",
                UPDATE_ENDPOINT,
                payload
            );

            if (response?.success) {
                toast.success("Group updated successfully!");
                navigate(routes.ManageSalesGroup);
            } else {
                toast.error(response?.message || "Update failed.");
            }
        } catch (error) {
            toast.error("Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    console.log("This is members :", members)


    return (
        <div className="page-wrapper">
            <div className="content">
                <h2>Edit Sales Group</h2>
                <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                    <div className="my-auto mb-2">
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <Link to={routes.adminDashboard}>
                                        <i className="ti ti-smart-home" />
                                    </Link>
                                </li>
                                <li className="breadcrumb-item">Dashboard</li>
                                <li className="breadcrumb-item">Group Management</li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Edit Sales Group
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <button
                        className="btn btn-outline-secondary"
                        onClick={() => navigate(-1)}
                    >
                        <i className="ti ti-arrow-left me-2" />
                        Back
                    </button>
                </div>
                {/* Card  */}
                <div className="card">
                    <div className="card-body">
                        {loading ? (
                            <Loading />
                        ) : (
                            <form>
                                {/* Group Name */}
                                <div className="mb-3">
                                    <label>Group Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.groupName}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                groupName: e.target.value,
                                            })
                                        }
                                    />
                                </div>

                                {/* Description */}
                                <div className="mb-3">
                                    <label>Description</label>
                                    <textarea
                                        className="form-control"
                                        rows={3}
                                        value={formData.description}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                description: e.target.value,
                                            })
                                        }
                                    />
                                </div>
                                {/* Selected Member */}
                                {/* <table className="table table-sm mb-0 align-middle">
                                    <thead className="table-light">
                                        <tr>
                                            {/* <th style={{ width: "40px" }}>
                                                // {/* Optional checkbox /}
                                            </th> */}
                                            {/* <th>Employee ID</th>
                                            <th>Name</th>
                                            <th>Phone</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {formData.selectedMembers.length > 0 ? (
                                            formData.selectedMembers.map((data: Member) => (
                                                <tr className="table-primary" style={{whiteSpace:"nowrap"}} key={data.employee_id}> 
                                                    <td >{data.organization_user_id}</td>
                                                    <td >{data.full_name}</td>
                                                    <td >{data.mobile_no}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={4} className="text-center text-muted py-2">
                                                    No members selected
                                                </td>
                                            </tr>
                                        )} */}
                                    {/* </tbody>
                                </table> */} 

                                {/* Member */}
                                <div className="mb-3 position-relative">
                                    <label className="form-label fw-semibold">Add Members</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search and add members..."
                                        value={formData.search}
                                        onChange={(e) =>
                                            setFormData((prev) => ({
                                                ...prev,
                                                search: e.target.value,
                                            }))
                                        }
                                        onFocus={() => setIsFocused(true)}
                                        onBlur={() =>
                                            setTimeout(() => setIsFocused(false), 150)
                                        }
                                    />

                                    {/* Select Edit members badges */}
                                    <div className="mt-2 mb-4">
                                        {formData.selectedMembers.length !== 0 && <p className="mb-2 fw-semibold" style={{ fontSize: "13px" }}>
                                            Selected Members
                                        </p>}

                                        <div className="d-flex flex-wrap gap-2">
                                            {formData.selectedMembers.map((m) => (
                                                <span
                                                    key={m.employee_id}
                                                    className="badge bg-primary d-flex align-items-center"
                                                >
                                                    {m.full_name}
                                                    <button
                                                        type="button"
                                                        className="btn-close btn-close-white ms-2"
                                                        style={{ fontSize: "0.6rem" }}
                                                        onClick={() => handleRemove(m.employee_id)}
                                                    ></button>
                                                </span>
                                            ))}
                                        </div>
                                    </div>

                                    {(isFocused || formData.search) && (
                                        <div
                                            className="dropdown-table-container"
                                            onMouseDown={(e) => e.preventDefault()}
                                        >
                                            <table className="table table-sm mb-0 align-middle">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th style={{ width: "40px" }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={
                                                                    filtered.length > 0 &&
                                                                    filtered.every((m) =>
                                                                        formData.selectedMembers.some(
                                                                            (s) => s.employee_id === m.employee_id
                                                                        )
                                                                    )
                                                                }
                                                                onChange={handleSelectAll}
                                                            />
                                                        </th>
                                                        <th>Employee ID</th>
                                                        <th>Name</th>
                                                        <th>Phone</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filtered.length > 0 ? (
                                                        filtered.map((m) => {
                                                            const isChecked = formData.selectedMembers.some(
                                                                (s) => s.organization_user_id === m.organization_user_id
                                                            );
                                                            return (
                                                                <tr
                                                                    key={m.employee_id}
                                                                    className={isChecked ? "table-primary" : ""}
                                                                >
                                                                    <td>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={isChecked}
                                                                            onChange={() => handleCheckboxSelect(m)}
                                                                        />
                                                                    </td>
                                                                    <td>{m.organization_user_id}</td>
                                                                    <td>{m.full_name}</td>
                                                                    <td>{m.mobile_no || "-"}</td>
                                                                </tr>
                                                            );
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td
                                                                colSpan={4}
                                                                className="text-center text-muted py-2"
                                                            >
                                                                No results found
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                                {/* Button */}
                                <div className="d-flex justify-content-end gap-2">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => navigate(-1)}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleUpdateGroup}
                                        disabled={loading}

                                    >
                                        {loading ? "Saving..." : "Save"}
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </div>

        </div>
    );
};

export default EditGroupPage;



